// angular
import { AfterViewInit, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreService } from '../../core/core.service';
import { AppService } from '../../app.service';

// others
import { MeRegisterService } from './me-register.service';
import { MeLoginService } from '../login/me-login.service';
import { AuthService } from '../../core/auth.service';

@Component({
    selector: 'me-register',
    templateUrl: './me-register.component.html',
    styleUrls: ['./me-register.component.scss'],
    providers: [MeRegisterService, MeLoginService]
})

export class MeRegisterComponent implements OnInit, AfterViewInit {
    registerSuccess = false;
    errorMessage = '';
    verifyToken = '';
    jwtToken = '';

    constructor(
        public meRegisterService: MeRegisterService,
        public route : ActivatedRoute,
        public router: Router,
        public coreService : CoreService,
        public appService: AppService,
        public authService : AuthService,
        public meLoginService: MeLoginService
    ) {
    }

    ngOnInit() {
        this.appService.isLoading = false;
        this.route.queryParams.subscribe(params => {
            if (params['verifyToken'] && params['verifyToken'] != '') {
                this.verifyToken = params['verifyToken'];
                this.meRegisterService.step = 6;
            }

            if (params['token'] && params['token'] != '') {
                if (this.router.url.indexOf('jwt') >= 0) {
                    // Handle register for jwt flow
                    this.meRegisterService.checkJwtToken(params['token']).subscribe(
                    res => {
                        this.applyToken(res);
                        localStorage.setItem('registerToken', params['token']);
                    },
                    error => {
                        this.errorMessage = error.error.error;
                    });
                    
                } else {

                    // Handle register for normal flow
                    this.meRegisterService.checkVoucher(params['token']).subscribe(res => {
                        this.appService.setMeClinicVoucher(params['token']);
                        this.applyToken(res);
                    });
                }
            }

            if (params['platform'] && params['platform'] != '') {
                this.appService.setMeClinicFlatform(params['platform']);
            }
        });
    }

    ngAfterViewInit() {
        this.coreService.className = 'me-landing-page';
    }

    goToDashboard() {
        if (this.meRegisterService.patientEmail === '' || this.meRegisterService.patientPassword === '') {
            return;
        }
        this.appService.isLoading = true;
        this.meLoginService.login(this.meRegisterService.patientEmail, this.meRegisterService.patientPassword).subscribe(res => {
            this.authService.saveToLocalStorage(res['email'], res);
            this.appService.isLoading = false;
            this.appService.callApiGetClinicConfig(res['clinic_id']).subscribe(res => {
                this.appService.storeMeClinicFolder(res);
                this.appService.setLanguage(res['locale'] || this.appService.activeLanguage.locale);
                this.appService.isLoading = false;
                this.router.navigate(['me/dashboard']);
            });
        });
    }

    applyToken(res) {
        this.appService.setMeClinicId(res['clinic_id']);
        this.appService.setMeClinicFolderViaClinicId(res['clinic_id']);
        this.router.navigate(['me/register'], {
            queryParams: {
                'token': null,
            }
        })
        this.coreService.className = 'me-landing-page';
    }
}
